import { ModalRedirectTranslations } from "./translations";
import { UsedVehicle } from "./used-inventory";

export enum ModalDisplayMode {
  REDIRECT_CARFAX_SITE = 'redirect_carfax_site',
  DEALER_SITE_HANDOFF = 'dealer_site_handoff',
  HANDOFF_BUYING = 'handoff_buying',
}

export interface ModalDisplay {
  active: boolean;
  mode?: ModalDisplayMode;
}
export enum ModalDisplayAction {
  'DISPLAY_MODAL' = 'display modal',
  'CLOSE_MODAL' = 'close modal',
}
export interface ModalDisplayReducer {
  action: ModalDisplayAction;
  mode?: ModalDisplayMode;
}


export interface RedirectLayerState {
  readonly text: string;
  readonly index: number;
  readonly vehicle?: UsedVehicle,
  readonly translations: ModalRedirectTranslations;
  readonly urlRedirect?: string;
  readonly onCloseHandler?: () => void;
}
